import React from 'react';
import { Bubble } from 'ctia-ui';

const NoDocs = () => {
  return <Bubble>No Supporting Documentation provided.</Bubble>;
};

export default NoDocs;
